import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class SigningTemplate extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  templateId: string;

  @autoserialize
  parentId: number;

  @autoserialize
  filename: string;

  @autoserialize
  providerName: string;

  @autoserialize
  isActive: boolean;

  @autoserializeAs(Date)
  requiredByDate: Date;

  static OnSerialized(instance: SigningTemplate, json: any): void {
    if (!isNullOrUndefined(instance.requiredByDate)) {
      json.requiredByDate = DateUtil.serializeLocalDate(instance.requiredByDate);
    }
  }

  static OnDeserialized(instance: SigningTemplate, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['requiredByDate'])) {
      instance.requiredByDate = DateUtil.deserializeLocalDate(json['requiredByDate']);
    }
  }
}
